import { render, staticRenderFns } from "./ToDoList.vue?vue&type=template&id=fa39d47e&scoped=true"
import script from "./ToDoList.vue?vue&type=script&lang=js"
export * from "./ToDoList.vue?vue&type=script&lang=js"
import style0 from "./ToDoList.vue?vue&type=style&index=0&id=fa39d47e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa39d47e",
  null
  
)

export default component.exports